import { normalizarCenario, type Cenario, type CenarioJson } from '../dominio/modelos/cenario'

export async function carregarCenarioMvp(): Promise<Cenario> {
  const resposta = await fetch('/cenarios/mvp-colisao-frontal-01.json')
  if (!resposta.ok) throw new Error(`Falha ao carregar cenário: HTTP ${resposta.status}`)
  return normalizarCenario(await resposta.json() as CenarioJson)
}
